import {
  ACTIVITY_PLAN_INTERVAL_MAPPING_SCHEMA,
  ActivityPlanInterval,
  MappingSchemaField,
} from '@warebee/shared/import-converter';
import { TFunction } from 'i18next';
import { keyBy } from 'lodash';
import i18n from '../../../i18n';
import { MappingSettings } from '../../store/import.types';

export function getActivityPlanSchema(
  t: TFunction<'dataset'> = i18n.t,
): MappingSettings<ActivityPlanInterval> {
  const baseFields = keyBy(
    ACTIVITY_PLAN_INTERVAL_MAPPING_SCHEMA.fields,
    f => f.name,
  ) as Record<
    keyof ActivityPlanInterval,
    MappingSchemaField<ActivityPlanInterval>
  >;

  return {
    ...ACTIVITY_PLAN_INTERVAL_MAPPING_SCHEMA,
    fields: [
      {
        ...baseFields.intervalId,
        title: t(`Interval ID`, { ns: 'dataset' }),
        description: t('A unique Interval ID', { ns: 'dataset' }),
        example: '123456789',
        aliases: ['id'],
      },
      {
        ...baseFields.employeeId,
        title: t('Employee ID', { ns: 'dataset' }),
        description: t('Employee ID', { ns: 'dataset' }),
        example: 'JOHNDOE',
        aliases: ['employeeId'],
        // valueResolver: baseFields.eventProcessType.defaultValueResolver,
      },

      {
        ...baseFields.shiftId,
        title: t('Shift ID', { ns: 'dataset' }),
        description: t('Shift ID', {
          ns: 'dataset',
        }),
        example: 'JOHNDOE-2025-01-01',
        aliases: ['shiftId'],
        //valueResolver: baseFields.eventType.defaultValueResolver,
      },
      {
        ...baseFields.shiftType,
        title: t('Shift TYPE', { ns: 'dataset' }),
        description: t('Shift Type', {
          ns: 'dataset',
        }),
        example: 'morning shift',
        aliases: ['shiftType'],
        //valueResolver: baseFields.eventType.defaultValueResolver,
      },
      {
        ...baseFields.intervalStart,
        title: t('Interval Start Time', { ns: 'dataset' }),
        description: t('Interval Start Time', {
          ns: 'dataset',
        }),
        example: '2020-01-01 15:58:01',
        aliases: ['intervalStart'],
        //valueResolver: baseFields.eventType.defaultValueResolver,
      },
      {
        ...baseFields.intervalEnd,
        title: t('Interval End Time', { ns: 'dataset' }),
        description: t('Interval End Time', {
          ns: 'dataset',
        }),
        example: '2020-01-01 15:58:01',
        aliases: ['intervalEnd'],
        //valueResolver: baseFields.eventType.defaultValueResolver,
      },
      {
        ...baseFields.intervalType,
        title: t('intervalType', { ns: 'dataset' }),
        description: t('intervalType', {
          ns: 'dataset',
        }),
        example: 'lunch',
        aliases: ['intervalType'],
        //valueResolver: baseFields.eventType.defaultValueResolver,
      },
      {
        ...baseFields.activityType,
        title: t('activityType', { ns: 'dataset' }),
        description: t('activityType', {
          ns: 'dataset',
        }),
        example: 'out of scope',
        aliases: ['activityType'],
        valueResolver: baseFields.activityType.defaultValueResolver,
      },
      {
        ...baseFields.shiftStart,
        title: t('Shift start time', { ns: 'dataset' }),
        description: t('Interval To Time', {
          ns: 'dataset',
        }),
        example: '2020-01-01 15:58:01',
        aliases: ['shiftStart'],
        //valueResolver: baseFields.eventType.defaultValueResolver,
      },
      {
        ...baseFields.shiftEnd,
        title: t('Shift end time', { ns: 'dataset' }),
        description: t('ShiftTo', {
          ns: 'dataset',
        }),
        example: '2020-01-01 15:58:01',
        aliases: ['shiftEnd'],
        //valueResolver: baseFields.eventType.defaultValueResolver,
      },
    ],
  };
}
